import styled, { css } from 'styled-components'
import React from 'react'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  h2 {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin-top: 0;
    margin-bottom: 24px;
    transition: all 0.3s ease;
    color: ${(props) => props.theme.colors.darkTextColor};
  }

  > p {
    font-size: 16px;
    line-height: 24px;
    margin-top: 0;
    transition: all 0.3s ease;
    color: ${(props) => props.theme.colors.darkGray};
  }
`

export const GiftCardsListContainer = styled.div`
  padding: 0px;
  transition: all 0.3s ease;

  > p {
    font-size: 20px;
    font-weight: 600;
    margin-top: 0px;
    transition: all 0.3s ease;
  }
`

export const GiftCardsWrapper = styled.div`
  margin-bottom: 10px;
  transition: all 0.3s ease;
`

export const GiftCardItem = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.gray200};
  margin-bottom: 20px;
  padding: 15px 20px 15px 10px;
  transition: all 0.3s ease;
  border-radius: 12px;

  ${({ isPage }) => isPage && css`
    border: 1px solid #E9ECEF;
    max-width: 410px;
    border-radius: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  `}

  &:hover {
    background-color: ${(props) => props.theme.colors.gray100};
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  .left-content {
    display: flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s ease;
  }

  button {
    font-size: 15px;
    font-weight: 500;
    min-width: fit-content;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  p {
    font-size: 16px;
    margin: 0;
    transition: all 0.3s ease;
  }

  .name {
    font-weight: 500;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .price {
    font-size: 14px;
  }
`

export const IconControl = styled.div`
  display: flex;
  color: ${props => props.theme.colors.primary};
  transition: all 0.3s ease;

  svg {
    font-size: 24px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  svg[disabled] {
    color: ${props => props.theme.colors.lightGray};
  }
`

export const ActionButtonContainer = styled.div`
  position: sticky;
  bottom: 0px;
  background-color: ${props => props.theme.colors.backgroundPage};
  padding: 20px 20px;
  transition: all 0.3s ease;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);

  > button {
    height: 44px;
    width: 100%;
    transition: all 0.3s ease;
    border-radius: 8px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
`

export const CardImageStyled = styled.div`
  box-sizing: border-box;
  position: relative;
  background-repeat: no-repeat, repeat;
  background-size: contain;
  background-position: center;
  object-fit: cover;
  height: 60px;
  width: 60px;
  min-width: 60px;
  min-height: 60px;
  margin: 0 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`

export const CardImage = (props) => {
  const style = {}
  if (props.bgimage) {
    style.backgroundImage = `url(${props.bgimage})`
  }
  if (props.soldOut) {
    style.filter = 'brightness(70%)'
  }
  return (
    <CardImageStyled {...props} style={style}>
      {props.children}
    </CardImageStyled>
  )
}
